import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../../theme/colors";

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  width: "100%",
});

export const ModalTitle = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  color: colors.text.primary,
  textAlign: "center",
});

export const ButtonsContainer = styled(Box)({
  display: "flex",
  gap: "24px",
  justifyContent: "center",
  "& button": {
    gap: "8px",
  },
});
